<template>
    <div class="preview-item" :style="{width: previewWidth + 'px', height: previewHeight + 'px'}"
         v-if="inner_data">
        <component :is="inner_data.type + 'Element'"
                   :data="inner_data"
                   :description="null"
                   :frame="previewFrame"
                   :info-styles="infoStyles"
                   :basic-content-styles="basicContentStyles"
                   :width="previewFrame.width"
                   :height="previewFrame.height"></component>
        <slot></slot>
    </div>
</template>

<script>
import textElement from '../elements/text.vue';
import rssfeedElement from '../elements/rssfeed.vue';
import iframeElement from '../elements/iframe.vue';
import youtubeElement from '../elements/youtube.vue';
import qrcodeElement from '../elements/qrcode.vue';
import countdownElement from '../elements/countdown.vue';
import pictureElement from '../elements/picture.vue';
import videoElement from '../elements/video.vue';
import pdfElement from '../elements/pdf.vue';
import pptElement from '../elements/ppt.vue';
import emptyrectangleElement from '../elements/emptyrectangle.vue';
import templateElement from '../elements/template.vue';
import campaignElement from '../elements/campaign.vue';
import clockElement from '../elements/clock.vue';
import dayElement from '../elements/day.vue';
import weatherElement from '../elements/weather.vue';
import layerElement from '../elements/layer.vue';
import esignElement from '../elements/esign.vue';
import streamingElement from '../elements/streaming.vue';
import widgetElement from '../elements/widget.vue';

export default {
    props: ['data', 'width', 'height', 'preview-width', 'preview-height'],
    components: {
        textElement,
        rssfeedElement,
        iframeElement,
        youtubeElement,
        qrcodeElement,
        countdownElement,
        pictureElement,
        videoElement,
        pdfElement,
        pptElement,
        emptyrectangleElement,
        templateElement,
        campaignElement,
        clockElement,
        dayElement,
        weatherElement,
        layerElement,
        esignElement,
        streamingElement,
        widgetElement,
    },
    data: function() {
        return {
            inner_data: null,
        }
    },
    computed: {
        basicContentStyles: function () {
            var width = '100%';
            var height = width;
            var margin = this.markArea ? '-1px' : '';
            var clip = this.markArea ? 'rect(1px,calc(100% + 1px),calc(100% + 1px),1px)' : '';

            return {
                //position: 'absolute',
                clip: clip,
                width: width,
                height: height,
                margin: margin,
                position: 'relative',
            }
        },
        infoStyles: function() {
            var left = 4;
            var bottom = 4;
            return {
                left: left + 'px',
                bottom: bottom + 'px',
            }
        },
        previewFrame: function () {
            return {
                width: this.previewWidth,
                height: this.previewHeight,
                ratio: this.previewWidth/this.width,
            }
        }
    },
    mounted() {
        this.inner_data = this.data;
    }
}
</script>
